import { defineMessages } from "react-intl";

export const feedbackMessages = defineMessages({
  title: {
    id: "6OV8CW",
    defaultMessage: "Feedback",
    description: "feedback page title",
  },
  subtitle: {
    id: "fexyKf",
    defaultMessage:
      "Complaints and opinions sent through the storefront feedback form. Each one was also e-mailed to the feedback mailbox.",
    description: "feedback list subtitle",
  },
  filterAll: {
    id: "8Vt8MW",
    defaultMessage: "All",
    description: "feedback filter",
  },
  filterOpen: {
    id: "YvOwbm",
    defaultMessage: "Open",
    description: "feedback filter",
  },
  filterResolved: {
    id: "P6hsQJ",
    defaultMessage: "Handled",
    description: "feedback filter",
  },
  kindAll: {
    id: "qEAoxy",
    defaultMessage: "All types",
    description: "feedback kind filter",
  },
  kindComplaint: {
    id: "NMyAm+",
    defaultMessage: "Complaint",
    description: "feedback kind",
  },
  kindOpinion: {
    id: "1ZXZU6",
    defaultMessage: "Opinion",
    description: "feedback kind",
  },
  searchPlaceholder: {
    id: "Bu6DA3",
    defaultMessage: "Search name, e-mail or message",
    description: "feedback search placeholder",
  },
  colDate: {
    id: "NboCNE",
    defaultMessage: "Date",
    description: "feedback column",
  },
  colKind: {
    id: "6JkRNJ",
    defaultMessage: "Type",
    description: "feedback column",
  },
  colFrom: {
    id: "Zy1qhs",
    defaultMessage: "From",
    description: "feedback column",
  },
  colMessage: {
    id: "H65tWL",
    defaultMessage: "Message",
    description: "feedback column",
  },
  colStatus: {
    id: "OlmMq1",
    defaultMessage: "Status",
    description: "feedback column",
  },
  markResolved: {
    id: "JlPFK1",
    defaultMessage: "Mark handled",
    description: "feedback action",
  },
  markOpen: {
    id: "E80S3U",
    defaultMessage: "Reopen",
    description: "feedback action",
  },
  empty: {
    id: "vG/+pq",
    defaultMessage: "No feedback yet.",
    description: "feedback empty list",
  },
  updateFailed: {
    id: "6/9Bww",
    defaultMessage: "Could not update the message.",
    description: "feedback update error",
  },
});
